export default "__VITE_ASSET__BONfXReM__"